// Yotpo Product Review Handler
document.addEventListener("DOMContentLoaded", function () {
  console.log("Yotpo handler initialized");

  // if Yotpo is loaded, initialize handlers
  if (window?.Yotpo) {
    initYotpoHandlers();
  } else {
    // wait for Yotpo to load
    const checkYotpo = setInterval(function () {
      if (window?.Yotpo) {
        clearInterval(checkYotpo);
        initYotpoHandlers();
      }
    }, 500);
  }

  function initYotpoHandlers() {
    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) {
            const fileInputs = node.querySelectorAll('input[type="file"]');
            fileInputs.forEach(attachFileHandler);

            if (node.querySelector) {
              const childFileInputs =
                node.querySelectorAll('input[type="file"]');
              childFileInputs.forEach(attachFileHandler);
            }
          }
        });
      });
    });

    const yotpoContainers = document.querySelectorAll(
      ".yotpo, [data-yotpo-product-id], .yotpo-widget-instance"
    );
    yotpoContainers.forEach(function (container) {
      observer.observe(container, {
        childList: true,
        subtree: true,
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    const existingFileInputs = document.querySelectorAll('input[type="file"]');
    existingFileInputs.forEach(attachFileHandler);

    function attachFileHandler(input) {
      // check if the input is a Yotpo input
      const isYotpoInput = input.closest(
        ".yotpo, [data-yotpo-product-id], .yotpo-widget-instance, .yotpo-review-form"
      );

      if (isYotpoInput) {
        // remove existing listeners to avoid duplicates
        input.removeEventListener("click", handleFileClick);
        input.removeEventListener("change", handleFileChange);

        // before file is selected
        input.addEventListener("click", handleFileClick);

        // after file is selected
        input.addEventListener("change", handleFileChange);
      }
    }

    function handleFileClick(e) {
      if (!window.ReactNativeWebView) return;

      e.preventDefault();
      e.stopPropagation();

      const fileInput = e.target;
      let isRequestingPermission = false;

      window.onPermissionResult = function (permissionType, granted) {
        if (permissionType === "CAMERA") {
          if (!granted && !isRequestingPermission) {
            isRequestingPermission = true;
            window.ReactNativeWebView.postMessage(
              JSON.stringify({
                type: "REQUEST_PERMISSION",
                permissionType: "CAMERA",
              })
            );
          } else if (granted) {
            isRequestingPermission = false;
            fileInput.removeEventListener("click", handleFileClick);
            fileInput.click();
            setTimeout(() => {
              fileInput.addEventListener("click", handleFileClick);
            }, 100);
          } else {
            isRequestingPermission = false;
          }
        }
      };

      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          type: "CHECK_PERMISSION",
          permissionType: "CAMERA",
        })
      );
    }

    function handleFileChange(e) {
      console.log("Yotpo file selected");
    }
  }
});
